import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showOuDefaultGcSettingsModal } from '../../../../actions/modal';
import { updateGCSettingCallForOU } from '../../../../actions/organisation';

const RightPanelUpdate = ({ setSaveButtonDisableClass, saveButtonDisableClass, validateForm, orgUnit }) => {
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const ouGcWaitingAreaSettings = useSelector((state) => state.organisationsReducer.ouGcSettings);
  const gcWaitngAreaOUSettingForm = useSelector((state) => state.organisationsReducer.gcWaitngAreaOUSettingForm);

  const updateGCSettings = () => {
    setSaveButtonDisableClass('');
    setIsUpdating(true);
    let cb = () => {
      setIsUpdating(false);
      dispatch(showOuDefaultGcSettingsModal(false));
    };
    dispatch(updateGCSettingCallForOU(orgUnit.networkId, gcWaitngAreaOUSettingForm, cb));
  };

  useEffect(() => {
    if (JSON.stringify(validateForm) !== JSON.stringify(gcWaitngAreaOUSettingForm)) {
      setSaveButtonDisableClass('');
    } else {
      setSaveButtonDisableClass('disable');
    }
  }, [gcWaitngAreaOUSettingForm]);

  const saveModalChange = (event) => {
    if (JSON.stringify(validateForm) !== JSON.stringify(gcWaitngAreaOUSettingForm)) {
      updateGCSettings();
    }
  };

  const closeModal = () => {
    dispatch(showOuDefaultGcSettingsModal(false));
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  return (
    <div>
      {ouGcWaitingAreaSettings?.isChatEditable || ouGcWaitingAreaSettings?.isCallerFullNameEditable ? (
        <div className="mrtxxs mrbl max-width">
          <button
            tabIndex="4"
            type="button"
            onClick={saveModalChange}
            data-group="GCSettings"
            className={isUpdating ? saveClasses + ' loading' : `${saveClasses} ${saveButtonDisableClass}`}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="mrbl max-width mrtxxs ">
          <button
            onClick={closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
};

export default RightPanelUpdate;
